import { Address, AddressService } from 'ui-utils';

export default function useAddress(value: Address) {
  return AddressService.toString(value);
}
